import React from "react";
import { IconCardComponentProps } from "../../constants/interface";
import { useTranslation } from "react-i18next";

const IconCardComponent = (props: IconCardComponentProps) => {
    const { classes = '', img, imgContainerClass, title, titleClass = '' , paragraph, paragraphClass = '', index, list } = props;
    const {t} = useTranslation();
    
    return (
        <div className={`flex flex-col gap-4 p-6 rounded-md lg:gap-5 ${classes}`}>
            <div className={`p-3 w-fit rounded-[0.625rem] ${imgContainerClass}`}>
                {
                    (img)?
                    (
                        <img loading="lazy" src={img} alt="" className="w-6" />
                    ) : (
                        <span className="w-6 inline-block text-center text-base font-medium leading-none">{(index + 1).toString().padStart(2,'0')}</span>
                    )
                }
            </div>
            <div className="flex flex-col gap-2">
                <p className={`text-lg font-semibold ${titleClass}`}>{t(title)}</p>
                <>
                    {
                        (paragraph) &&
                        <p className={`text-sm font-normal ${paragraphClass}`}>{t(paragraph)}</p>
                    }
                </>
                <>
                    {
                        (list && list.length > 0) &&
                        <div className="grid gap-5">
                            {
                                list.map((item, i) => (
                                    <p key={i} className={`text-sm font-normal text-gray-535 flex items-center ${(item.img) && 'gap-3'}`}>
                                        <span>
                                            <img loading="lazy" src={item.img || '/assets/images/svg/dot-gray-icon.svg'} alt="" className="w-7 min-w-7" />
                                        </span>
                                        <span>{t(item.paragraph || '')}</span>
                                    </p>
                                ))
                            }
                        </div>
                    }
                </>
            </div>
        </div>
    );
};

export default IconCardComponent;